import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="3jzx4q0zo8apx">
      {eyebrow && <p className={`text-sm font-extrabold uppercase tracking-wider ${dark ? 'text-brand' : 'text-brand-dark'}`} data-id="element-67" data-mp="3k29liatp0f1e">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 text-[28px] font-black leading-[1.1] tracking-tight text-balance sm:text-4xl lg:text-[44px] ${dark ? 'text-white' : 'text-ink'}`} data-id="element-68" data-mp="gieytz3glds5">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-mist' : 'text-muted'}`} data-id="element-69" data-mp="6rkdcwy1ei7r">{subtitle}</p>}
    </div>;
}